import { reloadAppAsync } from 'expo'
import ScreenTemplate from '@shell/ScreenTemplate'
import useOfflineModal from 'hooks/useOfflineModal'

export default function OfflineScreen() {
  const { isOpen } = useOfflineModal()

  const onPress = () => reloadAppAsync()

  if (!isOpen) return null

  return (
    <ScreenTemplate
      absolute
      icon="wifi-off"
      title={'Offline'}
      desc={
        'Unable to connect to the server.\nCheck your connection and try again.'
      }
      buttons={[{ label: 'Retry', onPress }]}
    />
  )
}
